import { useEffect, type ReactNode } from "react";
import { SponsorshipHero } from "@/features/sponsorship/components/layout/SponsorshipHero";
import { SponsorshipTabs } from "@/features/sponsorship/components/layout/SponsorshipTabs";
import { SponsorshipOnboardingWizard } from "@/features/sponsorship/components/onboarding/SponsorshipOnboardingWizard";
import { RecommendationModalProvider } from "@/features/sponsorship/context/RecommendationModalContext";
import { useRecommendations } from "@/features/sponsorship/hooks/useRecommendations";

type Props = { children: ReactNode };

// Couleur de fond de page de la feature — également consommée par les
// encoches du hub « ticket » (elles se découpent dans ce fond).
export const SPONSORSHIP_MAIN_BG_CLASS = "bg-violet-50";

const useSponsorshipMainBackground = () => {
  useEffect(() => {
    const main = document.querySelector("main");
    if (!main) return;
    main.classList.add(SPONSORSHIP_MAIN_BG_CLASS);
    return () => {
      main.classList.remove(SPONSORSHIP_MAIN_BG_CLASS);
    };
  }, []);
};

export const SponsorshipLayout = ({ children }: Props) => {
  useSponsorshipMainBackground();
  const { recommendations, isLoading } = useRecommendations();

  return (
    <RecommendationModalProvider>
      <div className="page-animation flex flex-col gap-6">
        <div className="flex flex-col gap-2 rounded-2xl bg-white p-2 shadow-sm dark:bg-gray-800">
          <SponsorshipHero />
          <div className="px-3 py-2">
            <SponsorshipTabs />
          </div>
        </div>
        {children}
        {/* Monté seulement une fois le discriminant connu : pas de flash du
            wizard pour un bénéficiaire actif (pré-marqué « vu » par le hook). */}
        {!isLoading && <SponsorshipOnboardingWizard hasRecommendations={recommendations.length > 0} />}
      </div>
    </RecommendationModalProvider>
  );
};

SponsorshipLayout.displayName = "SponsorshipLayout";
